<template>
  <div class="dropdown" id="tag-menu" v-show="isShowTag">
    <div
      aria-expanded="true"
      aria-haspopup="true"
      class="dropdown-toggle"
      data-toggle="dropdown"
      id="dropdownMenu2"
    >
      <i class="iconfont icon-tag"></i>
      {{selectedTag}}
      <span class="caret"></span>
    </div>
    <div aria-labelledby="dropdownMenu2" class="dropdown-menu dropdown-menu-right">
      <div class="taglist">
        <a v-show="tags.length" @click="searchByTags(null)">全部</a>
        <a v-for="tag in tags" :key="tag.tag_number" @click="searchByTags(tag)">{{ tag.tag_name }}</a>
        <a v-show="!tags.length">暂无标签</a>
      </div>
    </div>
  </div>
</template>

<script>
import { resourceTagAllList } from "@/api/drive/tag";
export default {
  props: {
    isShowTag: Boolean
  },
  name: "Tag",
  data() {
    return {
      tag: null,
      tags: [],
      isOpen: false
    };
  },
  computed: {
    selectedTag() {
      if (!this.tag) {
        return "标签";
      }
      return this.tag;
    },
    groupNumber() {
      return this.$store.state.drive.groupNumber;
    }
  },
  methods: {
    resourceTagAllList() {
      resourceTagAllList({
        group_number: this.groupNumber,
        disk_type: "cloud"
      })
        .then(res => {
          if (res.status_code === 200) {
            this.tags = res.entity;
          } else {
            this.$message({
              type: "error",
              message: res.message
            });
          }
        })
        .catch(err => {
          this.$message({
            type: "error",
            message: err
          });
        });
    },
    searchByTags(tag) {
      if (tag) {
        this.tag = tag.tag_name;
        this.$store.dispatch("searchByTags", {
          group_number: this.groupNumber,
          disk_type: "cloud",
          category: "all",
          is_star: false,
          tag: tag.tag_number
        });
      } else {
        this.tag = null;
        this.$store.dispatch("getInfo");
      }
    }
  },
  mounted() {
    let that = this;
    $("#tag-menu").on("show.bs.dropdown", function() {
      that.resourceTagAllList();
    });
  }
};
</script>

<style scoped>
.active {
  color: #006adf;
}
</style>